import { Alert, Box, Modal, Paper, Snackbar, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import './styles.scss';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Lottie from 'react-lottie-player';
import animationData from '../pages/loader.json'; // Local animation file


function Records() {
    const navigate = useNavigate();
    const [snackbarOpen, setSnackbarOpen] = useState({
      visible: false,
      text: '',
    });
    const [records, setRecords] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    
  const isMobile = window.innerWidth >=769 ? false : true;
  const modalWidth = window.innerWidth >=769 ? '80vw' : '90vw';

    const [moreDetailsModal, setMoreDetailsModal] = useState({
        visible: false,
        item: {}
    })

    useEffect(() => {
        setIsLoading(true);
        fetch('https://livinghealthyme.com/server/records.php', {
            method: 'GET',
            credentials: 'include'
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            setIsLoading(false);
            return response.json();
        })
        .then(data => {
            if(data?.success){
                setRecords(data?.records);
            }else{
                navigate('/adminlogin');
                setSnackbarOpen({
                    visible: true,
                    text: 'Oppss! Something went wrong. Please try again later.'
                })
            }
            setIsLoading(false);
        })
        .catch(error => {
            setIsLoading(false);
            navigate('/adminlogin');
            console.error('Error fetching records:', error);
        });
    }, []);

    useEffect(() => {
        if (moreDetailsModal?.visible) {
            // Prevent background scrolling
            document.body.style.overflow = 'hidden';
        } else {
            // Restore scrolling
            document.body.style.overflow = '';
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        };
    }, [moreDetailsModal?.visible]);

    const Loader = () => {
        // Styles for the overlay and loader container
        const styles = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.1)', // light translucent background
                backdropFilter: 'blur(1px)', // adds the blur effect
                zIndex: 9999,
            },
            loaderContainer: {
                position: 'relative',
                width: 300,
                height: 300,
            },
        };
  
        return (
            <div style={styles.overlay}>
                <div style={styles.loaderContainer}>
                    <Lottie
                        loop
                        animationData={animationData} // JSON animation data
                        play // autoplay
                        style={{ width: 300, height: 300 }}
                    />
                </div>
            </div>
        );
    };

    const logout = async() =>{
        try{
            const response = await fetch('https://livinghealthyme.com/server/logout.php', {
                method: 'POST',
                credentials: 'include'
            });
            const result = await response.json();
            if (result.status === 'success') {
              console.log(result.message); // 👉 "Logged out"
              // Redirect or update state here
              navigate('/adminlogin');
            } else {
              console.error('Logout failed:', result.message);
            }
        } catch (error) {
            console.error('Network or server error:', error);
        }
    }

    const modalStyle = {
        width: modalWidth,
        position: 'absolute',
        top: '50%',
        left: '50%',
        maxHeight: '60vh',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#FFF',
        border: '2px solid #004376',
        boxShadow: 24,
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column'
    };

    return (
        <div className="records">
            {
            isLoading &&
                <Loader />
            }
            <Snackbar open={snackbarOpen?.visible} autoHideDuration={5000} onClose={() => setSnackbarOpen({
                visible: false,
                text: '',
                state: snackbarOpen?.state ?? 'error'
                })} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert
                    onClose={() => setSnackbarOpen({
                    visible: false,
                    text: '',
                    state: snackbarOpen?.state ?? 'error'
                    })}
                    severity={snackbarOpen?.state ?? 'error' }
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    { snackbarOpen?.text }
                </Alert>
            </Snackbar>
            <Stack 
                className='records_header' 
                direction="row" 
                justifyContent="flex-end"
                alignItems="center"
                spacing={2}
            >
                <Stack
                    sx={{ cursor: 'pointer' }}
                    onClick={() => {
                        logout();
                    }}
                >
                    Logout
                </Stack>
            </Stack>
            <Stack className='records_container'>
                {
                    records?.length > 0 ?
                    <Stack>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell align="left">Email</TableCell>
                                    <TableCell align="left">Contact #</TableCell>
                                    <TableCell align="left">Health Concern</TableCell>
                                    <TableCell align="left">Date</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {records.map((row) => (
                                    <TableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row" sx={{ textTransform: 'capitalize' }}>
                                            {row.name}
                                        </TableCell>
                                        <TableCell align="left">{row.email}</TableCell>
                                        <TableCell align="left">{row.phone}</TableCell>
                                        <TableCell sx={{
                                                maxWidth: 200,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                cursor: 'pointer'
                                            }}
                                            align="left"
                                            onClick={() => setMoreDetailsModal({
                                                    visible: true, item: {
                                                        name: row.name,
                                                        health_concern: row.health_concern
                                                    }
                                                })
                                            }
                                        >
                                            {row.health_concern}
                                        </TableCell>
                                        <TableCell align="left">{row.date_created}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Stack> :
                    <Stack sx={{ padding: '20px' }}>
                        {
                            isLoading ? 'Getting Records' : 'There are no records to display'
                        }
                    </Stack>
                }
            
            </Stack>
            
            <Stack className='records_container_mobile'>
                <Stack className='records_wrapper'>
                {
                    records?.length > 0 ?
                    
                        records.map((row) => (
                            <Stack className='records_row_details'>
                                <Stack sx={{ textTransform: 'capitalize', flexDirection: 'row', alignItems: 'center' }}>
                                    <Typography>
                                        Name : 
                                    </Typography>
                                    <Typography sx={{ marginLeft: '10px', color: '#464646' }}>
                                        { row?.name }
                                    </Typography>
                                </Stack>
                                <Stack sx={{ marginTop: '10px', flexDirection: 'row', alignItems: 'center' }}>
                                    <Typography>
                                        Email : 
                                    </Typography>
                                    <Typography sx={{ marginLeft: '10px', color: '#464646' }}>
                                        { row?.email }
                                    </Typography>
                                </Stack>
                                <Stack sx={{ marginTop: '10px', flexDirection: 'row', alignItems: 'center' }}>
                                    <Typography>
                                        Contact # : 
                                    </Typography>
                                    <Typography sx={{ marginLeft: '10px', color: '#464646' }}>
                                        { row?.phone }
                                    </Typography>
                                </Stack>
                                <Stack sx={{ marginTop: '10px' }}>
                                    <Typography>
                                        Health Concern: 
                                    </Typography>
                                    <Typography 
                                        sx={{
                                            textIndent: '20px',
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            WebkitLineClamp: 3,
                                            overflow: 'hidden',
                                            color: '#464646',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => setMoreDetailsModal({
                                                visible: true, item: {
                                                    name: row.name,
                                                    health_concern: row.health_concern
                                                }
                                            })
                                        }
                                    >
                                        { row?.health_concern }
                                    </Typography>
                                </Stack>
                                <Stack sx={{ textAlign: 'right', marginTop: '10px', fontSize: '14px', color: '#464646' }}>
                                    { row?.date_created }
                                </Stack>
                            </Stack> 
                        ))
                    
                     :
                    <Stack sx={{ padding: '20px' }}>
                        {
                            isLoading ? 'Getting Records' : 'There are no records to display'
                        }
                    </Stack>
                }

                </Stack>
            </Stack>

            <Modal
                open={moreDetailsModal?.visible}
                onClose={() => setMoreDetailsModal({
                    visible: false, item: {}
                })}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box style={modalStyle} sx={{
                        '&:focus': {
                        outline: 'none',
                        },
                    }}>
                    <Stack className='modalHeader'
                        sx={{
                            backgroundColor: '#004376',
                            padding: '20px',
                            textTransform: 'capitalize',
                            color: '#fff',
                            fontSize: '24px'
                        }}
                    >
                        <Stack>
                            { moreDetailsModal?.item?.name }
                        </Stack>
                    </Stack>
                    <Stack className='modalBody'
                        sx={{
                            padding: '20px',
                            textIndent: '30px',
                            color: '#212121',
                            fontSize: '18px',
                            overflowY: 'auto',
                            maxHeight: 'calc(80vh - 60px)'
                        }}
                    >
                        <Stack>
                        { moreDetailsModal?.item?.health_concern }
                        
                        <span className='modalFooter'
                            sx={{
                                height: '50px'
                            }}
                        ></span>
                        </Stack>
                    </Stack>
                    <span className='modalFooter'
                        sx={{
                            height: '4px'
                        }}
                    ></span>
                </Box>
            </Modal>
        </div>
    );
}

export default Records;
